import React from "react";
import { useTranslation } from "react-i18next";
import { useProjectResourcesRetrieval } from "@planzone/view-models";

import { Filter, Props } from "./types";
import { ResourcesFilter } from "./resourcesFilter";
import { DateFilter } from "./dateFilter";
import styles from "./styles.scss";

function FilterForm({ filter, project, setFilter }: Props) {
  const { t } = useTranslation();
  const {
    projectResources,
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    retrieveProjectResources,
  } = useProjectResourcesRetrieval(project);

  React.useEffect(() => {
    !!project.uuid &&
      !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectResources(project);
  }, [project.uuid]);

  return (
    <div className={styles.filters}>
      <div className={styles.section}>
        <p className={styles.label}>
          {t("projectPage.documentsPage.reportsPage.filters.date")} :
        </p>
        <DateFilter
          selectedFilter={filter.date}
          selectFilter={(date) => setFilter({ ...filter, date })}
        />
      </div>
      <div className={styles.section}>
        <p className={styles.label}>
          {t("projectPage.documentsPage.reportsPage.filters.author")} :
        </p>
        <ResourcesFilter
          resources={projectResources.map(({ resource }) => resource)}
          selectedResources={filter.resources}
          selectResource={(resource) =>
            setFilter({
              ...filter,
              resources: [...filter.resources, resource],
            })
          }
          unSelectResource={(resource) =>
            setFilter({
              ...filter,
              resources: filter.resources.filter(
                ({ uuid }) => uuid !== resource.uuid,
              ),
            })
          }
        />
      </div>
    </div>
  );
}

export type { Filter };

export { FilterForm };
